module.exports = __webpack_public_path__ + "img/Notification-icon.ef1b1d51.svg";